<template>
  <div class="home-content-page-v prediction-page">
    <div class="content-1">
      <div class="gu-duan">
        <el-select v-model="oilStation" filterable placeholder="请选择加油站">
          <el-option v-for="item in predictionGasList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="content-1-tables">
        <div class="content-1-table-1 mii-table">
          <content-title title="进销存数据"></content-title>
          <mii-base-table2 :datas="showData" :rowDef="true" :ths="jxcThs"></mii-base-table2>
        </div>
        <div class="content-1-table-2 mii-table">
          <content-title title="预测结果"></content-title>
          <mii-base-table2 :datas="showData" :rowDef="true" :ths="jxcThs2"></mii-base-table2>
        </div>
      </div>
    </div>
    <div class="content-2">
      <div class="content-2-table mii-table">
        <content-title :title="'每日订单 ' + preDay" :actions="actions" @clickMenu="clickMenu"></content-title>
        <mii-base-table2 :datas="preDayData" :ths="jxcThs3" :scroll_table="true"></mii-base-table2>
      </div>
      <div class="content-2-note" v-if="showNote">
        日销量预测分析步骤：<br>
        1.时间趋势检验：通过线图以及Dickey-Fuller对数据进行检验，如果时间趋势不稳定，则需要对数据进行分解和转换。<br>
        2.自相关，偏相关函数分析，选择匹配时间序列数据的模型 - ARIMA<br>
        3.模型拟合以及检验：用RStudio中tseries已经forecast程序包进行分析，检验和预测。模型检验参数赤池信息法(AIC)，贝叶斯信息法(BIC)数值最终用来判断模型的拟合。<br>
        断货时间点预测:<br>
        我们针对5个加油站(昭通昭阳元宝山加油站，昭通昭阳头道沟加油站，昆明安宁丰营加油站，昆明西山照壁加油站，玉溪易门蒲贝加油站)，利用其20天的历史数据，运用上述分析方法，预测出之后三天内的订单情况。<br>
        订单紧急程度划分说明：<br>
        1.可配送订单：24小时<断货时间点≤48小时；<br>
        1.紧急订单：断货时间点≤24小时。
      </div>
      <div class="content-2-btn">
        <div class="btn-top-jiao">
        </div>
        <a href="javascript:;" @click="showNote = !showNote">预<br>测<br>分<br>析<br>方<br>法</a>
        <div class="btn-bottom-jiao">
        </div>
      </div>
    </div>
    <div class="content-2">
      <div class="content-3-table mii-table">
        <content-title :title="'小罐多销加油站'"></content-title>
        <mii-base-table2 :datas="dxData" :ths="jxcThs4" :scroll_table="true"></mii-base-table2>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable2 from '@/components_bit/MiiBaseTable2'
import {
  mapCp,
  outPutExcelFile
} from '@/cllib'

export default {
  name: 'cars',
  components: {
    ContentTitle,
    MiiBaseTable2
  },
  data () {
    return {
      actions: [{
        icon: 'icon-daochu',
        key: 'output'
      }],
      pageParm: {
        row_num: 10,
        dataTotal: 0
      },
      pageParm2: {
        row_num: 10,
        dataTotal: 0
      },
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '油品类型',
        key: '油品名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '时间',
        key: '时间'
      },
      {
        label: '期初库存(L)',
        key: '期初库存'
      },
      {
        label: '入库升数(L)',
        key: '入库升数'
      },
      {
        label: '出库升数(L)',
        key: '出库升数'
      },
      {
        label: '期末库存(L)',
        key: '期末库存'
      },
      {
        label: '空容(L)',
        key: '空容'
      }],
      jxcThs2: [{
        label: '平均销量(L)',
        key: '平均销量'
      },
      {
        label: '建议配送升数(L)',
        key: '建议配送量'
      },
      {
        label: '消耗率',
        key: '消耗率'
      },
      {
        label: '断货时间点',
        key: '断货时间'
      },
      {
        label: '订单紧急程度',
        key: '订单紧急程度'
      }],
      jxcThs3: [{
        label: '订单类型',
        key: '订单紧急程度',
        style: (data) => {
          if (data === '紧急订单') {
            return {
              'background-color': '#012e53',
              'color': '#00ccff'
            }
          } else if (data === '可配送订单') {
            return {
              'background-color': '#98aab9'
            }
          }
        }
      },
      {
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '油品',
        key: '油品名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '空容',
        key: '空容'
      },
      {
        label: '平均销量',
        key: '平均销量'
      },
      {
        label: '建议配送升数(L)',
        key: '建议配送量'
      },
      {
        label: '断货时间点',
        key: '断货时间'
      }],
      jxcThs4: [{
        label: '加油站名称',
        key: '加油站名称'
      },
      {
        label: '油品类型',
        key: '油品名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '平均销量',
        key: '平均销量'
      },
      {
        label: '有效容积',
        key: '有效容积'
      },
      {
        label: '有效容积-平均销量',
        key: 'sub'
      }],
      start_index: 0,
      start_index_dx: 0,
      showNote: false,
      row_num: 10,
      oilStation: ''
    }
  },
  methods: {
    clickMenu (key) {
      console.log()
      let datas = [{
        data: [],
        sheetName: 'data1'
      }]
      let row1 = []
      for (let key in this.preDayData[0] || {}) {
        row1.push(key)
      }
      datas[0].data.push(row1)
      this.preDayData.forEach(function (item) {
        let oneData = []
        row1.forEach((itemKey) => {
          oneData.push(item[itemKey])
        })
        datas[0].data.push(oneData)
      })
      outPutExcelFile(datas, '每日订单（' + this.preDay + '）.xls')
    },
    pageChange (currentPage) {
      this.start_index = (currentPage - 1) * this.row_num
    },
    pageChangeDx (currentPage) {
      this.start_index_dx = (currentPage - 1) * this.row_num
    }
  },
  computed: {
    showData: {
      get () {
        let data = []
        let allData = this.$store.getters.predictionDatas || []
        if (allData) {
          let vm = this
          allData.forEach(function (item) {
            if (item.oil === vm.oilStation) {
              item.data.forEach(function (itemC) {
                data.push(mapCp(itemC))
              })
            }
          })
          let row1 = {}
          let row2 = {}
          data.forEach(function (item, index) {
            let data1 = item['加油站名称']
            if (!row1[data1]) {
              row1[data1] = {index: index, data: {label: data1, rowspan: 1}}
            } else {
              row1[data1].data.rowspan ++
              item['加油站名称'] = {label: data1, rowspan: 0}
            }
            let data2 = item['油品名称']
            if (!row2[data2]) {
              row2[data2] = {index: index, data: {label: data2, rowspan: 1}}
            } else {
              row2[data2].data.rowspan ++
              item['油品名称'] = {label: data2, rowspan: 0}
            }
          })
          for (let key in row1) {
            data[row1[key].index]['加油站名称'] = row1[key].data
          }
          for (let key in row2) {
            data[row2[key].index]['油品名称'] = row2[key].data
          }
        }
        return data
      }
    },
    dxData: {
      get () {
        let datas = this.$store.getters.predictionDatasXD
        this.pageParm2.dataTotal = datas.length
        return datas
      }
    },
    preDay: {
      get () {
        return this.$store.getters.todayStr
      }
    },
    preDayData: {
      get () {
        let newData = []
        let data = this.$store.getters.predictionDatasDay
        data.forEach(function (item) {
          newData.push(item)
        })
        this.pageParm.dataTotal = newData.length
        return newData
      }
    },
    predictionGasList: {
      get () {
        let data = this.$store.getters.predictionGasList
        this.oilStation = data ? data[0] : ''
        return data
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.flowStatus < 20) {
      next({name: 'single.single'})
    } else {
      next()
    }
  },
  created () {
    this.$store.dispatch('prediction')
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.content-2-page {
  display: flex;
  justify-content: flex-end;
}
.btn-top-jiao {
  width: 0;
  height: 0;
  border-bottom: 0.81em solid #486881;
  border-left: 1.7em solid transparent;
}
.btn-bottom-jiao {
  width: 0;
  height: 0;
  border-top: 0.81em solid #486881;
  border-right: 1.7em solid transparent;
}
.content-2 {
  padding: 1.88em 0 4.8em 0.7em;
  display: flex;
  justify-content: space-between;
  background: #e0e0e0;
  border-radius: 0.5em;
  border-top: 2px dashed #bbb;
}
.content-2-table {
  background: #fff;
  width: 68%;
}
.content-3-table {
  background: #fff;
  width: 99%;
}
.content-3-table-2 {
  background: #fff;
  width: 38%;
}
.content-2-note {
  .content-shadow;
  .content-top-radius;
  .content-bottom-radius;
  padding: 2em 1.5em;
  color: #081633;
  line-height: 1.9;
  font-size: 0.8em;
  margin: 0 0.7em 0 1.88em;
  background: #fff;
  flex: 1;
}
.content-2-btn {
  width: 1.7em;
  line-height: 1.1;
  display: flex;
  flex-direction:column;
  text-align: center;
  a {
    font-size: 0.8em;
    color: #fff;
    background: #486881;

  }
}
.content-1-table-1 {
  width: 68%;
}
.content-1-table-2 {
  flex: 1;
  background:#fff;
  margin-left: 0.7em;
  display: flex;
  flex-direction:column;
}
.gu-duan {
  margin-bottom:0.7em;
  width: 100%;
  .el-select {
    width: 25em;
  }
}
.content-1 {
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
  display: flex;
  flex-direction:column;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table-2 {
  background-color: @bak-color-td-1;
}
.pagination-table {
  text-align: right;
  margin-right: 0.5em;
}
.mii-table {
  .content-shadow;
  .content-top-radius;
  display: flex;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .data-td {
    width: 10%;
  }
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    td {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
  }
}
</style>

<style lang="less">
.prediction-page {
  .gu-duan .el-select .el-input .el-input__icon {
    background: #081633;
    color: #fff;
    width: 5em;
    transition: none;
  }
  .gu-duan .el-input__icon+.el-input__inner {
    padding-left: 2.3em;
  }
}
</style>



// WEBPACK FOOTER //
// prediction.vue?3b4ba76f